import React, { useState } from "react";
import "../App.css";

const StoryVideo = ({ t }) => {
    const copy = t.storyVideo;
    const YT_ID = "0iwUwyYVEQs";
    const [play, setPlay] = useState(false);

    return (
        <div className="i story-video">
            <div className="story-video-inner">
                <div className="story-video-head">
                    <h1>{copy.title}</h1>
                </div>

                <div className="story-video-frame">
                    {!play ? (
                        <button
                            className="story-video-poster"
                            type="button"
                            onClick={() => setPlay(true)}
                            aria-label={copy.playAria}
                        >
                            <picture className="story-video-poster-picture">
                                <source srcSet="/story-preview.webp" type="image/webp" />
                                <img className="story-video-poster-img" src="/story-preview.png" alt="" />
                            </picture>

                            <span className="story-video-play" aria-hidden="true">
                                <span className="story-video-play-btn" />
                            </span>
                        </button>
                    ) : (
                        <iframe
                            src={`https://www.youtube.com/embed/${YT_ID}?autoplay=1&rel=0&modestbranding=1&playsinline=1`}
                            title={copy.iframeTitle}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default StoryVideo;
